export enum QuizPanelMode {
  VIEW = 'VIEW',
  TAKE = 'TAKE',
}

// Above this many questions, VIEW mode paginates the list client-side.
export const QUIZ_VIEW_PAGE_SIZE = 50;
